import { options } from '@master/model/options/Options'

export const TransactionTypeList = ['Buy', 'RSP', 'Fund Switch', 'Withdrawal', 'Top-up'] as const
export const TransactionTypeOptions: options[] = TransactionTypeList.map(transactionType => {
  return {
    label: transactionType,
    value: transactionType
  }
})
